module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/locale/pt/summary.json
// module id = elUY
// module chunks = 64